import { render, staticRenderFns } from "./SettlementTech.vue?vue&type=template&id=cb47e4c6&"
import script from "./SettlementTech.vue?vue&type=script&lang=js&"
export * from "./SettlementTech.vue?vue&type=script&lang=js&"
import style0 from "./SettlementTech.vue?vue&type=style&index=0&id=cb47e4c6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports